/**
 * Click-to-chat helpers for WhatsApp customer support (SRS §4.2, F-011).
 * The number is injected at build time; when unset the helpers return null so
 * callers can hide the control rather than link to a broken chat.
 */
const NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER;

export function whatsappLink(message: string): string | null {
  if (!NUMBER) return null;
  return `https://wa.me/${NUMBER}?text=${encodeURIComponent(message)}`;
}

/** Prefilled enquiry for a specific product, including a link back to its page. */
export function productEnquiryLink(productName: string, slug: string): string | null {
  const url = `${window.location.origin}/products/${slug}`;
  return whatsappLink(
    `Hello SkyTech Solutions, I'm interested in "${productName}". ${url}`,
  );
}
